import React, { Fragment } from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import Fade from "react-bootstrap/Fade";

import Close from "../../Icons/Close";
import Link from "../Link";

const propTypes = {
  show: PropTypes.bool,
  onHide: PropTypes.func,
  width: PropTypes.number,
  position: PropTypes.oneOf(["start", "end"])
};

const defaultProps = {
  width: 520,
  show: false,
  position: "end",
  onHide: () => {}
};

const Side = ({ show, onHide, width, position, children, ...props }) => {
  return (
    <Fragment>
      <Wrapper $show={show} {...{ width, position, ...props }}>
        <div
          className="px-6 py-2 d-flex justify-content-end bg-white"
          style={{ position: "sticky", top: 0, zIndex: 1 }}
        >
          <Link className="p-2" onClick={onHide}>
            <Close />
          </Link>
        </div>
        {children}
      </Wrapper>
      {/* sidenav backdrop */}
      <Fade in={show} mountOnEnter unmountOnExit onClick={onHide}>
        <div className="modal-backdrop" style={{ zIndex: 999 }} />
      </Fade>
    </Fragment>
  );
};

/**
 * style
 */
const Wrapper = styled.div`
  top: 0;
  width: 100%;
  height: 100%;
  z-index: 1000;
  position: fixed;
  overflow-y: auto;
  background-color: #fff;
  transition: ease-in-out 0.15s all;
  max-width: ${({ width }) => `${width * 0.0625}rem`};
  ${({ position, width, $show }) => {
    if (position === "start") {
      return `
        left: ${$show ? "0" : "-100vw"};

        @media (min-width: 768px) {
            left: ${$show ? "0" : `-${width * 0.0625}rem`};
        }
      `;
    }

    if (position === "end") {
      return `
        right: ${$show ? "0" : "-100vw"};

        @media (min-width: 768px) {
            right: ${$show ? "0" : `-${width * 0.0625}rem`};
        }
      `;
    }
  }}

  .modal-side__body {
    min-height: calc(100% - (56px + 80px));
  }

  .modal-side__footer {
    bottom: 0;
    z-index: 1;
    width: 100%;
    position: sticky;
  }
`;

Side.propTypes = propTypes;
Side.defaultProps = defaultProps;

export default Side;
